<template>
  <div>
    <section class="content">
      <div class="row">
        <form @submit.prevent="sendComment">
          <div class="col-md-12">
            <div class="box box-info">
              <div class="box-body">
                <!-- calendar group -->
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <label for="comment">Pedido</label>
                    </div>
                    <div class="col-md-9">
                      <textarea class="form-control" type="text" rows="5" name="comment" id="comment" placeholder="Pedido de actualización de datos" v-model="comment" required/></textarea>
                    </div>
                  </div>
                </div>
                <br/><br/><br/><br/><br/><br/><br/><br/>
                <div class="col-md-12">
                  <div class="col-md-8">
                    <div class="col-md-3">
                      <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Enviar pedido</button>
                    </div>
                  </div>
                </div>
                <!-- /input-group -->
              </div>
              <!-- /.box-body -->
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="success" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-green"><i class="ion ion-android-checkmark-circle"></i></span>
                <div class="info-box-content">
                  
                  <span class="info-box-info">{{success}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
import datepicker from 'vue-date-picker'
import api from '../../api'

export default {
  name: 'Settings',
  components: {
    datepicker
  },
  data (router) {
    return {
      section: 'ChangePsw',
      loading: '',
      comment: '',
      response: null,
      success: null,
      idUser: this.$store.state.user.idUser
    }
  },
  computed: {
    datetime () {
      return new Date()
    }
  },
  methods: {
    sendComment () {
      const {idUser, comment} = this

      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      api.request('GET', 'api/sendComment?idUser=' + idUser + '&comment=' + comment)
        .then(response => {
          this.toggleLoading()
          this.invoices = null

          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos suministrados son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'La factura no se encuentra.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              this.success = data.success
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}
</style>



// WEBPACK FOOTER //
// Comments.vue?e83a68e6